import { useState, useEffect, useRef } from "react";
import { ChangeAlertCallbackType, ChangeLoaderCallbackType } from "../../../Root";
import { useDialog } from "@albo-ui/core";
import { CommonService } from "../../../../services/CommonService";
import { AlboQueryService } from "../../../../services/AlboQueryService";
import { closelightbox } from "../../../../util/Functions";

export const useValidateClabe = (open: boolean, changeAlert: ChangeAlertCallbackType, changeLoader: ChangeLoaderCallbackType, setWidgets, updateNext) => {
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [list, setList] = useState([]);
    const [zPos, setZPos] = useState(45);
    const dialogProps = useDialog();
    const commonService = useRef<CommonService>();
    const alboQueryService = useRef<AlboQueryService>();

    const onSelectFile = (e) => {
        changeLoader(true);
        setZPos(-1);

        let csv = e.target.files[0];
        if (!csv) {
            changeAlert(true, "error", "Error en selección de archivo");
        } else if (csv.type !== "text/csv") {
            changeAlert(true, "error", "Error: El tipo de archivo permitido es CSV");
        } else {
            let reader = new FileReader();

            if (csv) {
                reader.readAsDataURL(csv);
                reader.onload = ((binding) => {
                    return async () => {
                        let parts = reader.result.toString().split(",")[1];
                        const response = await commonService.current.simpleCsvToJson(parts);
                        if (response?.data?.response === "OK") {
                            setList(response.data.content);
                            setIsValidForm(false);
                        } else {
                            setList([]);
                            changeAlert(true, "error", response.data.message);
                        }
                        changeLoader(false);
                        setZPos(45);
                    };
                })(this);
            }
        }
    };

    
    const deleteFromList = async (element) => {
        const cleanList = list.filter((item) => {
            return item !== element;
        });
        if (cleanList.length <= 100) {
            setIsValidForm(false);
        } else {
            setIsValidForm(true);
        }
        setList(JSON.parse(JSON.stringify(cleanList)));
    };

    const onClose = () => {
        dialogProps.onClose();
    };

    const onConfirm = async (lala) => {
        let user = JSON.parse(localStorage.session);
        changeLoader(true);
        setZPos(-1);

        let data = {
            aql: `from stp_tools where cmd='consultaCuentas'; cuentas='${list.toString()}'`,
            agent: user["uuid"],
        };

        const response = await alboQueryService.current.executeQuery(data);
        if (response.data.response === "OK") {
            let widg = response.data.widget;
            setWidgets(JSON.parse(JSON.stringify(widg)));
            updateNext("update");
            closelightbox();
            changeLoader(false);
        } else {
            setWidgets([]);
            changeLoader(false);
            setZPos(45);
        }
    };

    useEffect(() => {
        commonService.current = new CommonService(changeAlert);
        alboQueryService.current = new AlboQueryService(changeAlert);

        if (!open) {
            setList([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return {
        list,
        zPos,
        isValidForm,
        onSelectFile,
        onClose,
        onConfirm,
        deleteFromList,
    };
};
